module.exports = require("multer-s3");


//////////////////
// WEBPACK FOOTER
// external "multer-s3"
// module id = 16
// module chunks = 0